import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledTitleBox = styled(Box)`
    display: flex;
    width: 100%;
    height: 48px;
    justify-content: center;
    align-items: center;
    font-family: Roboto;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0;
    color: white;
`;
